module.exports = __webpack_public_path__ + "img/IMG_9432_L_Wood_MockedUp.dffcb91d.jpg";